import React, { Component } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const data = [
    {
        date: '22/03/02',
        H2: 1,
        CH4: 2,
        C2H6: 2,
        C2H4: 2,
        C2H2: 7,
        CO: 150
    },
    {
        date: '22/03/03',
        H2: 1,
        CH4: 0,
        C2H6: 1,
        C2H4: 2,
        C2H2: 5,
        CO: 100
    },
    {
        date: '22/03/04',
        H2: 1,
        CH4: 0,
        C2H6: 1,
        C2H4: 2,
        C2H2: 5,
        CO: 100
    },
    {
        date: '22/03/05',
        H2: 7,
        CH4: 2,
        C2H6: 2,
        C2H4: 18,
        C2H2: 4,
        CO: 110
    },
    {
        date: '22/03/06',
        H2: 12,
        CH4: 3,
        C2H6: 3,
        C2H4: 12,
        C2H2: 7,
        CO: 125
    }
];


export class HydrocarbonTrend extends Component {

    render() {
        return (
            <>
                <LineChart
                    width={500}
                    height={400}
                    data={data}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis dataKey="H2"/>
                    <Tooltip />
                    <Legend />
                    <Line type="monotone" dataKey="H2" stroke="#236adb" activeDot={{ r: 8 }} />                    
                    <Line type="monotone" dataKey="CH4" stroke="#bd7d0f"  activeDot={{ r: 8 }} />
                    <Line type="monotone" dataKey="C2H6" stroke="#706d6b" activeDot={{ r: 8 }} />
                    <Line type="monotone" dataKey="C2H4" stroke="#c5cf15" activeDot={{ r: 8 }} />
                    <Line type="monotone" dataKey="C2H2" stroke="#27b9e6" activeDot={{ r: 8 }} />
                    <Line type="monotone" dataKey="CO" stroke="#0b8c21" activeDot={{ r: 8 }} />
                </LineChart>
            </>
        );
    }
}

export default HydrocarbonTrend;
